var _circle, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconConfirmation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.5,
    r: 12,
    fill: "#FDE0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.633 7.50348C10.2954 7.79115 9.87568 7.965 9.43357 8.00028C8.40187 8.08261 7.58261 8.90187 7.50028 9.93357C7.465 10.3757 7.29115 10.7954 7.00348 11.133C6.33217 11.9207 6.33217 13.0793 7.00348 13.867C7.29115 14.2046 7.465 14.6243 7.50028 15.0664C7.58261 16.0981 8.40187 16.9174 9.43357 16.9997C9.87568 17.035 10.2954 17.2088 10.633 17.4965C11.4207 18.1678 12.5793 18.1678 13.367 17.4965C13.7046 17.2088 14.1243 17.035 14.5664 16.9997C15.5981 16.9174 16.4174 16.0981 16.4997 15.0664C16.535 14.6243 16.7088 14.2046 16.9965 13.867C17.6678 13.0793 17.6678 11.9207 16.9965 11.133C16.7088 10.7954 16.535 10.3757 16.4997 9.93357C16.4174 8.90187 15.5981 8.08261 14.5664 8.00028C14.1243 7.965 13.7046 7.79115 13.367 7.50348C12.5793 6.83217 11.4207 6.83217 10.633 7.50348Z",
    fill: "#FFA6A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.35 12.5L11.45 13.6L13.925 11.125M9.43357 8.00028C9.87568 7.965 10.2954 7.79115 10.633 7.50348C11.4207 6.83217 12.5793 6.83217 13.367 7.50348C13.7046 7.79115 14.1243 7.965 14.5664 8.00028C15.5981 8.08261 16.4174 8.90187 16.4997 9.93357C16.535 10.3757 16.7088 10.7954 16.9965 11.133C17.6678 11.9207 17.6678 13.0793 16.9965 13.867C16.7088 14.2046 16.535 14.6243 16.4997 15.0664C16.4174 16.0981 15.5981 16.9174 14.5664 16.9997C14.1243 17.035 13.7046 17.2088 13.367 17.4965C12.5793 18.1678 11.4207 18.1678 10.633 17.4965C10.2954 17.2088 9.87568 17.035 9.43357 16.9997C8.40187 16.9174 7.58261 16.0981 7.50028 15.0664C7.465 14.6243 7.29115 14.2046 7.00348 13.867C6.33217 13.0793 6.33217 11.9207 7.00348 11.133C7.29115 10.7954 7.465 10.3757 7.50028 9.93357C7.58261 8.90187 8.40187 8.08261 9.43357 8.00028Z",
    stroke: "url(#paint0_linear_527_12310)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_527_12310",
    x1: 6.5,
    y1: 7,
    x2: 17.6879,
    y2: 7.1945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4112E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConfirmation);
export default __webpack_public_path__ + "static/media/IconConfirmation.b7366f1fd1fcd8b07613855702214066.svg";
export { ForwardRef as ReactComponent };